import { useMemo, useRef } from 'react';

import { useCountUp } from '../../hooks/useCountUp';
import { useReducedMotion } from '../../presence/useReducedMotion';
import './StatTicker.css';

type Props = {
  line: string;
  motionKilled?: boolean;
};

const NUMBER_RE = /(\d[\d,]*)/;

function formatWithCount(line: string, count: number) {
  const match = line.match(NUMBER_RE);
  if (!match || match.index == null) return line;
  const formatted = count.toLocaleString();
  return `${line.slice(0, match.index)}${formatted}${line.slice(match.index + match[0].length)}`;
}

export function StatTicker({ line, motionKilled = false }: Props) {
  const ref = useRef<HTMLParagraphElement>(null);
  const reduced = useReducedMotion();
  const still = motionKilled || reduced;

  const target = useMemo(() => {
    const match = line.match(NUMBER_RE);
    if (!match) return 0;
    return Number.parseInt(match[1].replace(/,/g, ''), 10) || 0;
  }, [line]);

  const count = useCountUp(ref, target, { disabled: still || target <= 0 });
  const display = target > 0 && !still ? formatWithCount(line, count) : line;

  if (!line.trim()) return null;

  return (
    <p ref={ref} className="stat-ticker" role="status" aria-live="polite">
      <span className="stat-ticker__dot" aria-hidden />
      <span>{display}</span>
    </p>
  );
}
